import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { ItemTypeDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-itemtype-container',
  templateUrl: './itemtype-container.component.html',
  styleUrls: ['./itemtype-container.component.scss']
})
export class ItemTypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  itemtypes$: Observable<ItemTypeDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("ItemType");
    this.itemtypes$ = this.gatwayFacade.loadGateway("ItemType");
    this.itemtypes$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteItemType(deletedValue: any) {
    this.gatwayFacade.remove("ItemType", deletedValue);
    // this.store.dispatch(ItemTypeStoreActions.removeItemType({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitItemType(formValue: any) {
    console.log("form value: ", formValue);
    formValue.ItemTypes = formValue.ItemTypes.reverse();
    event.preventDefault();
    const pullData = formValue.ItemTypes;
    //const newPullData = formValue.ItemTypees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllItemType = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllItemType.push(pullData[i]);
    }
  }

// check if the addAllItemType array is not empty, then dispatch the data to the store
   if(addAllItemType.length !== 0) {
    this.gatwayFacade.add('ItemType', addAllItemType);
    // this.store.dispatch(ItemTypeStoreActions.addItemType({newItemType: addAllItemType}));

   }

// dispatch update data to the store
this.gatwayFacade.update('ItemType', allUpdates, ['id']);
    // this.store.dispatch(ItemTypeStoreActions.updateItemType({updateItemType: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



